import { type LocationArt } from '../dtos';

export const locationArtLabels = {
  HOTEL: 'Hotel',
  VERANSTALTUNGSLOCATION: 'Veranstaltungslocation (ohne Übernachtungsmöglichkeit)',
  PC_CENTER: 'PC-Center (ohne Übernachtungsmöglichkeit)',
} as const satisfies Record<LocationArt, string>;
